import { useState } from "react";

type QueryFilter = Record<string, any>;
type QuerySort = Record<string, any> | null;

interface UseEntityQueryParamsParams {
  filter?: QueryFilter;
  defaultLimit?: number;
  defaultSort?: QuerySort;
  sanitize?: (filter: QueryFilter) => QueryFilter;
}

/**
 * Parâmetros de consulta das listagens — filtro, ordenação, página e limite
 *
 * @param filter - Filtro inicial
 * @param defaultLimit - Itens por página, quando a tela não usa 20
 * @param defaultSort - Ordenação com que a listagem nasce
 * @param sanitize - Ajusta o filtro no valor inicial e depois de cada mescla
 * @returns Os quatro estados, seus setters e os dois handlers
 */
export const useEntityQueryParams = ({
  filter: filterInitial,
  defaultLimit,
  defaultSort = null,
  sanitize,
}: UseEntityQueryParamsParams = {}) => {
  const [filter, setFilter] = useState<QueryFilter>(() => {
    const initial = filterInitial || {};
    return sanitize ? sanitize(initial) : initial;
  });
  const [sort, setSort] = useState<QuerySort>(defaultSort);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(defaultLimit || 20);

  const handleFilter = (value: QueryFilter) => {
    setPage(1);
    setFilter((curr) => {
      const merged = { ...curr, ...value };
      return sanitize ? sanitize(merged) : merged;
    });
  };

  const handleSort = (value: QuerySort) => {
    setPage(1);
    setSort(value);
  };

  return {
    filter,
    setFilter,
    handleFilter,
    sort,
    setSort,
    handleSort,
    page,
    setPage,
    limit,
    setLimit,
  };
};
